import { render, staticRenderFns } from "./SecondAuth.vue?vue&type=template&id=5403a406&scoped=true"
import script from "./SecondAuth.vue?vue&type=script&lang=js"
export * from "./SecondAuth.vue?vue&type=script&lang=js"
import style0 from "./SecondAuth.vue?vue&type=style&index=0&id=5403a406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403a406",
  null
  
)

export default component.exports